import React from "react";
import { howBodyCodingWorks } from "../../../data/body-coding/how-body-coding-works";
import TitleCard from "../../shared/TitleCard";

const HowBodyCodingWorks = () => {
    return (
        <div className="px-4 px-md-5">
            <h2 className="text-md-center fw-bold display-5 mb-md-5 pb-5">{howBodyCodingWorks.heading}</h2>
            <div className="row px-md-5">
                {howBodyCodingWorks.content.map((card, index) => (
                    <div key={index} className="col-12 col-md-6 col-xxl-4 d-flex align-items-stretch mb-4">
                        <TitleCard title={card.title} description={card.description} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HowBodyCodingWorks;